<template>
  <hm-content>
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="openRuleSelector"
          >添加规则</el-button
        >
        <!-- <el-button type="primary" size="small" @click="allocationPlusRule"
          >PLUS基础配置</el-button
        > -->
      </div>
      <div class="flex">
        <el-select
          clearable
          style="width: 120px"
          v-model="searchCondition.cardType"
          placeholder="卡类型"
          size="small"
          class="mr10"
        >
          <el-option label="基础卡" value="basic"></el-option>
          <el-option label="联名卡" value="increase"></el-option>
        </el-select>
        <el-select
          clearable
          style="width: 120px"
          v-model="searchCondition.enableState"
          placeholder="状态"
          size="small"
          class="mr10"
        >
          <el-option label="启用" value="yes"></el-option>
          <el-option label="停用" value="no"></el-option>
        </el-select>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.cardName"
          placeholder="请输入规则名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="plusRuleList.records"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="规则名称"
          prop="cardName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="卡类型"
          prop="cardType"
        >
          <template v-slot="scope">
            <span v-if="scope.row.cardType === 'basic'"> 基础卡 </span>
            <span v-else> 联名卡 </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="updateTime"
          label="最后修改时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wxshopSpuName"
          label="绑定权益商品（虚拟商品）"
        >
        </el-table-column>

        <el-table-column header-align="center" align="center" label="状态">
          <template v-slot="scope">
            <span
              :class="scope.row.enableState === 'yes' ? 'success' : 'danger'"
              >{{ scope.row.enableState === "yes" ? "启用" : "停用" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <!-- <el-button
                type="text"
                size="small"
                class="mr10"
                @click="updateStatus(scope.row)"
              >
                {{ scope.row.enableState === "yes" ? "停用" : "启用" }}
              </el-button> -->

              <el-tooltip
                class="item"
                :content="scope.row.enableState === 'no' ? '启用' : '停用'"
                placement="top"
              >
                <div class="pointer mr10" @click="updateStatus(scope.row)">
                  <span
                    class="hmicon  blue"
                    :class="
                      scope.row.enableState === 'no'
                        ? 'icon-shangxian'
                        : 'icon-xiaxian'
                    "
                  ></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="编辑" placement="top">
                <div class="pointer mr10" @click="toRule('edit', scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="plusRuleList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="70%"
      :before-close="handleClose"
      :visible.sync="tagModalVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="200px"
      >
        <el-form-item label="规则名称（会员别称）" prop="cardName">
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            style="width: 270px"
            v-model.trim="ruleForm.cardName"
            placeholder="请输入规则名称，建议不超过10个文本"
          ></el-input>
        </el-form-item>
        <el-form-item label="会员权益绑定商品" prop="wxshopSpuName">
          <el-input
            size="small"
            class="mr10 ipt"
            style="width: 270px"
            :show-message="showGoodsSn"
            v-model.trim="ruleForm.wxshopSpuName"
            placeholder="请选择绑定权益商品（虚拟商品）"
            @click.native="selectGood"
            readonly
          ></el-input>
          <!-- <div>
            <el-checkbox v-model="ruleForm.checked"
              >续费权益绑定商品</el-checkbox
            >
          </div>
          <el-input
            :disabled="!ruleForm.checked"
            size="small"
            class="mr10 ipt"
            style="width:270px"
            :show-message="showGoodsSn"
            v-model.trim="ruleForm.wxshopSpuNames"
            placeholder="请选择绑定权益商品（虚拟商品）"
            @focus="selectGoods"
            readonly
          ></el-input> -->
        </el-form-item>
        <el-form-item label="权益效期" prop="remark">
          <el-input
            size="small"
            type="number"
            clearable
            class="mr10 ipt"
            @input="filterGt0OrFixed('remark')"
            v-model.trim="ruleForm.remark"
            placeholder="请输入数字"
          ></el-input
          >个月
          <div class="form-item-tip">
            购买权益商品后，会员身份权益升级，当到期后，权益失效
          </div>
        </el-form-item>
        <el-form-item label="权益配置" prop="quota">
          每月领取优惠券限额 &nbsp;
          <el-input
            size="small"
            clearable
            class="mr10 ipt"
            @input="filterGt0OrFixed2('quota')"
            v-model.trim="ruleForm.quota"
            placeholder="请输入数字"
          ></el-input
          >元
          <div class="form-item-tip">
            设置后PLUS会员将会在每月获得对应额度的PLUS会员领券额度，具体信息在优惠券发放中设置为“PLUS会员领券”即可
          </div>
          <div class="form-item-tip">
            注意，设置券规则的时候请设置为PLUS会员专用券，以保障PLUS会员权益生效；
          </div>
          <div class="form-item-tip">
            设置后若对该数据进行修改，已经成为PLUS会员的额度不会发生变化，仅对新的PLUS会员有效。
          </div>
        </el-form-item>
        <!-- <el-form-item label="节省信息配置" prop="typeName">
          <el-switch
            active-value="true"
            inactive-value="false"
            active-color="#13ce66"
 
            v-model="ruleForm.enableState"
          ></el-switch>
        </el-form-item> -->
        <el-form-item label="权益说明" prop="description">
          <el-input
            size="small"
            clearable
            type="textarea"
            placeholder="请输入权益说明，200字内"
            :rows="5"
            :cols="45"
            v-model.trim="ruleForm.description"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm('ruleForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="canel">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="PLUS基础配置"
      width="1000px"
      :visible.sync="plusModalVisible"
    >
      <el-form ref="ruleForms" :model="ruleForms" label-width="120px">
        <div class="title">会员卡升级规则</div>
        <el-table
          :data="ruleForms.cardRuleRelList"
          style="width: 100%"
          stripe
          size="small"
          border
          class="mb10"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="PLUS会员绑定会员卡类型"
            prop="originCardTypeIdList"
          >
            <template slot-scope="scope">
              <el-select
                size="small"
                clearable
                style="width: 335px"
                v-model="scope.row.originCardTypeIdList"
                class="mr10"
                placeholder="请选择PLUS会员绑定会员卡类型（ERP对接可用）"
                filterable
                @change="cardTypeChange(scope.row.originCardTypeIdList)"
                multiple
              >
                <el-option
                  label="全部"
                  value="0"
                  :disabled="checked"
                  @click.native="selectAll(scope.$idnex)"
                ></el-option>
                <el-option
                  v-for="(item, i) in vipCardTypeList.records"
                  :key="i"
                  :label="item.typeName"
                  :value="item.cardTypeId"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="绑定升級卡类型"
            prop="PLUS会员绑定会员卡类型"
          >
            <template slot-scope="scope">
              <el-select
                size="small"
                clearable
                style="width: 335px"
                v-model="scope.row.targetCardTypeId"
                class="mr10"
                placeholder="请选择绑定升級卡类型"
                filterable
              >
                <el-option
                  v-for="(item, i) in allVipCardTypeList"
                  :key="i"
                  :label="item.typeName"
                  :value="item.cardTypeId"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <div
                  class="add-wrapper flex flex-center"
                  v-if="scope.$index === 0"
                >
                  <span
                    class="hmicon icon-hao pointer"
                    @click="addChild(scope.$index)"
                  ></span>
                </div>
                <div class="minus-wrapper flex flex-center" v-else>
                  <span
                    class="hmicon icon-jianhao pointer"
                    @click="deleteChild(scope.$index)"
                  ></span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-form-item label="PLUS会员绑定会员卡类型" prop="typeName">
          <el-select
            size="small"
            clearable
            style="width:335px"
            v-model="ruleForms.cardTypeId"
            class="mr10"
            placeholder="请选择PLUS会员绑定会员卡类型（ERP对接可用）"
            filterable
            multiple
          >
            <el-option
              v-for="(item, i) in vipCardTypeList.records"
              :key="i"
              :label="item.typeName"
              :value="item.cardTypeId"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="PLUS会员卡规则" prop="typeName">
          <el-select
            size="small"
            clearable
            style="width: 335px"
            v-model="ruleForms.plusRuleId"
            class="mr10"
            placeholder="请选择PLUS会员卡规则（设置即生效）"
            filterable
          >
            <el-option
              v-for="(item, i) in plusRuleList.records"
              :key="i"
              :label="item.cardName"
              :value="item.plusRuleId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宣传图" prop="typeName">
          <my-upload
            field="file"
            :headers="{ 'X-Access-Token': $token }"
            :params="{ fileDir: 'goodsCenter' }"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="show"
            noCircle
            noSquare
            :width="660"
            :height="272"
            :url="$uploadUrl"
            img-format="png"
          ></my-upload>
          <el-button
            type="primary"
            size="small"
            v-show="!ruleForms.imageUrl"
            @click="toggleShow"
            >点击上传</el-button
          >

          <div class="priview" v-if="ruleForms.imageUrl">
            <img :src="ruleForms.imageUrl" alt="主图" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemove">删除</el-button>
            </div>
          </div>
        </el-form-item>
        <div class="btn-wrapper mb20 flex flex-center">
          <el-button size="small" type="primary" @click="savePlus"
            >确 定</el-button
          >
          <el-button size="small" @click="plusModalVisible = false"
            >取 消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      custom-class="import-dialog"
      title="添加商品"
      width="70%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <div class="p20">
        <div class="table-panel flex flex-between">
          <div class="flex text-right flex-end">
            <el-input
              clearable
              style="width: 200px"
              v-model.trim="searchDialogCondition.keyWords"
              placeholder="请输入货号/条码/商品名称"
              size="small"
              class="ipt mr10"
            ></el-input>

            <el-input
              clearable
              v-model.trim="searchDialogCondition.minPrice"
              placeholder="最低零售价"
              size="small"
              style="width: 100px"
              class="ipt mr10"
            ></el-input>
            <el-input
              clearable
              v-model.trim="searchDialogCondition.maxPrice"
              placeholder="最高零售价"
              size="small"
              style="width: 100px"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="searchGoods"
              >查询</el-button
            >
            <el-button
              type="info"
              size="small"
              @click="searchDialogCondition = {}"
              >重置</el-button
            >
          </div>
        </div>
        <div class="table mb20">
          <div class="tips mb20">提示：点击表格行即可选择</div>
          <el-table
            stripe
            border
            ref="brandTable"
            @current-change="handleCurrentChange"
            highlight-current-row
            @selection-change="getChecked"
            :data="virtualGoods.records"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              :index="
                index => index + (currentVirtualPage - 1) * pageVirtualSize + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="wxshopSpuName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsSnAndBarcode"
              show-overflow-tooltip
              label="规格"
            >
              <template slot-scope="scope">
                <div>
                  <!-- <span>{{ scope.row.spuAttributeValueList.join() }}</span> -->
                  <span>{{ scope.row.specIdGroupName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="类别"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="价格信息"
            >
              <template slot-scope="scope">
                <div>
                  <span>零售价：</span>
                  <span class="rose">{{ scope.row.wxshopPrice }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="virtualGoods.total"
            @current-change="pagingVirtual"
            @size-change="handleSizeVirtualChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentVirtualPage"
          ></el-pagination>
        </div>
        <div class="btn-wrapper mb20 flex flex-center">
          <el-button size="small" type="primary" @click="save">确 定</el-button>
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="选择规则类型"
      :visible.sync="ruleDialogVisible"
      :close-on-click-modal="false"
    >
      <div class="rule-dialog-body">
        <el-radio-group class="flex" v-model="cardType">
          <el-radio label="basic">
            <div
              class="radio-inner basic"
              :class="{ active: cardType === 'basic' }"
            >
              <span
                v-show="cardType === 'basic'"
                class="hmicon icon-duigou"
              ></span>
            </div>
          </el-radio>
          <el-radio label="increase">
            <div
              class="radio-inner increase"
              :class="{ active: cardType === 'increase' }"
            >
              <span
                v-show="cardType === 'increase'"
                class="hmicon icon-duigou"
              ></span>
            </div>
          </el-radio>
        </el-radio-group>
      </div>
      <div class="btn-wrapper mt20 mb20 flex flex-center">
        <el-button size="small" type="primary" @click="toRule">确 定</el-button>
        <el-button size="small" @click="ruleDialogVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import myUpload from "vue-image-crop-upload";
export default {
  components: { myUpload },
  data() {
    return {
      tHeader: ["品牌名称（必填）", "品牌首字母"],
      tBody: ["brandName", "brandAcronym"],
      importTempVisible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      dueDatepickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() < Date.now() ||
            time.getTime() > Date.now() + 280 * 8.64e7
          );
        }
      },
      cardType: "basic",
      ruleDialogVisible: false,
      plusModalVisible: false,
      setMemberDialogVisible: false,
      dialogVisible: false,
      inputVisible: false,
      showFamilyCase: false,
      detailsModalVisible: false,
      searchDialogCondition: {},
      setMemberIdDialogVisible: false,
      inputValue: "",
      keyWords: "",
      searchCondition: {},
      checkedRow: {},
      ruleForm: {
        cardName: "",
        wxshopSpuName: "",
        checked: "",
        remark: "",
        quota: "",
        description: "",
        plusRuleId: "",
        wxshopSkuId: ""
      },

      ruleForms: {
        cardRuleRelList: [{ originCardTypeIdList: [], targetCardTypeId: "" }],
        imageUrl: "",
        cardTypeId: "",
        plusRuleId: ""
      },
      rules: {
        wxshopSpuName: [
          {
            required: true,
            message: "请选择绑定权益商品",
            trigger: "blur"
          }
        ],
        cardName: [
          {
            required: true,
            message: "请输入会员姓名",
            trigger: "blur"
          },
          { max: 10, message: "长度不超过10个字符", trigger: "blur" }
        ],
        remark: [
          {
            required: true,
            message: "请输入权益效期",
            trigger: "blur"
          }
        ],
        quota: [
          {
            required: false,
            message: "请输入每月领取优惠券限额",
            trigger: "blur"
          }
        ],
        description: [
          {
            message: "长度在 200 个字符内",
            trigger: "blur",
            min: 0,
            max: 200
          }
        ]
      },
      show: false,
      title: "添加会员",
      mode: "add",
      keyword: "",
      level: 0,
      parentCategoryId: "",
      parentCategoryName: "",
      tagModalVisible: false,
      categoryName: "",
      currentRow: {},
      tableData1: [],
      currentPage: 1,
      showGoodsSn: true,
      pageSize: 10,
      currentVirtualPage: 1,
      pageVirtualSize: 10,
      currentPageEmployee: 1,
      pageSizeEmployee: 10,
      createTimeStart: "",
      createTimeEnd: "",
      isHaveMemberCard: "",
      defaultCardId: "",
      centerId: "",
      detMemberMgt: {
        storeMemberCenterInfoVo: [],
        cardInfoVoList: [],
        familyInfoVoList: []
      },
      detailMember: [],
      checkedEmployee: [],
      isOutputing: false,
      cardId: "",
      wxshopSkuId: "",
      checked: false,
      allVipCardTypeList: []
    };
  },
  computed: mapGetters(["virtualGoods", "plusRuleList", "vipCardTypeList"]),
  watch: {},
  created() {},
  mounted() {
    // this.queryVirtualList();

    this.queryList();
  },
  methods: {
    async updateStatus(row) {
      const relType = row.enableState === "no" ? "启用" : "停用";
      const result = await this.$confirm(
        `${relType}${row.cardName}规则?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      );
      if (result === "confirm") {
        await this.$store.dispatch("changePlusRuleStatus", {
          plusRuleId: row.plusRuleId,
          enableState: row.enableState === "yes" ? "no" : "yes"
        });
        this.queryList();
      }
    },
    addChild() {
      this.ruleForms.cardRuleRelList.push({
        originCardTypeIdList: [],
        targetCardTypeId: ""
      });
      this.validation();
    },
    deleteChild(index) {
      this.ruleForms.cardRuleRelList.splice(index, 1);
      this.validation();
    },
    selectAll(index) {
      // this.list[index].cardTypeId = [];
      // if (this.checked) {
      //   this.vipCardTypeList.records.map(item => {
      //     this.list[index].cardTypeId.push(item.cardTypeId);
      //   });
      // } else {
      //   this.list[index].cardTypeId = [];
      // }
    },
    cardTypeChange(val) {
      this.validation();
      // let cardList = [];
      // this.ruleForms.cardRuleRelList.forEach(v => {
      //   cardList.push(...v.originCardTypeIdList);
      // });
      // if (cardList.length === 0) {
      //   this.checked = false;
      //   this.vipCardTypeList.records.filter(v => {
      //     v.disabled = false;
      //   });
      // } else {
      //   if (cardList.indexOf("0") === 0) {
      //     this.checked = true;
      //     this.vipCardTypeList.records.filter(v => {
      //       v.disabled = true;
      //     });
      //   } else {
      //     this.checked = true;

      //     this.vipCardTypeList.records.filter(v => {
      //       if (cardList.indexOf(v.cardTypeId) !== -1) {
      //         v.disabled = true;
      //       } else {
      //         v.disabled = false;
      //       }
      //     });
      //   }
      // }
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.ruleForms.imageUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    // 移除上传文件
    handleRemove() {
      this.ruleForms.imageUrl = "";
    },
    deleteListHeader() {
      this.$refs.editorUpload.handleRemove();
    },
    save() {
      if (!this.currentRow.spuId) {
        this.$message({
          type: "warning",
          message: "请先选择商品"
        });
      } else {
        // this.$store.dispatch("queryGoodsDetails", {
        //   spuId: this.currentRow.spuId
        // });

        this.dialogVisible = false;
        this.wxshopSkuId = this.currentRow.wxshopSkuId;
        this.ruleForm.wxshopSpuName = this.currentRow.wxshopSpuName;
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;

          this.$store.dispatch("addMemberMgt", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.setMemberDialogVisible = false;
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    allocationPlusRule() {
      this.plusModalVisible = true;
      // this.queryAllVirtualList();
      let params = {
        pageSize: 99999,
        pageNo: 1
      };
      // this.$store.dispatch("queryVipCardTypeList", params);
      this.queryDetails();
    },
    async queryAllVirtualList() {
      let params = {
        pageSize: 99999,
        pageNo: 1
      };
      const { result } = await this.$store.dispatch(
        "queryAllVipCardTypeList",
        params
      );
      this.allVipCardTypeList = result.records;
    },
    edit(row) {
      this.title = "编辑会员规则";
      this.tagModalVisible = true;
      for (let key in row) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = row[key];
        }
      }
    },
    selectGood() {
      this.dialogVisible = true;
    },
    selectGoods() {
      this.dialogVisible = true;
    },
    queryVirtualList() {
      let params = {
        pageSize: this.pageVirtualSize,
        pageNo: this.currentVirtualPage,
        spuType: "virtual"
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );
      Object.assign(params, searchDialogCondition);
      this.$store.dispatch("virtualGoods", params);
    },
    searchGoods() {
      this.currentVirtualPage = 1;
      this.queryVirtualList();
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },

    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },

    handleSizeVirtualChange(size) {
      this.currentVirtualPage = 1;
      this.pageSize = size;
      this.queryVirtualList();
    },
    pagingVirtual(page) {
      this.currentVirtualPage = page;
      this.queryVirtualList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },

    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.createTimeStart =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.createTimeEnd =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";

      Object.assign(params, searchCondition);
      return this.$store.dispatch("plusRuleList", params);
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    validation() {
      let cardList = [];
      this.ruleForms.cardRuleRelList.forEach(v => {
        cardList.push(...v.originCardTypeIdList);
      });
      if (cardList.length === 0) {
        this.checked = false;
        this.vipCardTypeList.records.filter(v => {
          v.disabled = false;
        });
      } else {
        if (cardList.indexOf("0") === 0) {
          this.checked = true;
          this.vipCardTypeList.records.filter(v => {
            v.disabled = true;
          });
        } else {
          this.checked = true;
          this.vipCardTypeList.records.filter(v => {
            if (cardList.indexOf(v.cardTypeId) !== -1) {
              v.disabled = true;
            } else {
              v.disabled = false;
            }
          });
        }
      }
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("queryDetailsConfigInfo");
      for (let key in this.ruleForms) {
        this.ruleForms[key] = result[key];
      }
      if (this.ruleForms.cardRuleRelList.length === 0) {
        this.ruleForms.cardRuleRelList.push({
          originCardTypeIdList: [],
          targetCardTypeId: ""
        });
      } else {
        this.validation();
      }
      // if (cardList.length === 0) {
      //   this.checked = false;
      //   this.vipCardTypeList.records.filter(v => {
      //     v.disabled = false;
      //   });
      // } else {
      //   if (cardList.indexOf("0") === 0) {
      //     this.checked = true;
      //     this.vipCardTypeList.records.filter(v => {
      //       v.disabled = true;
      //     });
      //   } else {
      //     this.checked = true;

      //     this.vipCardTypeList.records.filter(v => {
      //       if (cardList.indexOf(v.cardTypeId) !== -1) {
      //         v.disabled = true;
      //       } else {
      //         v.disabled = false;
      //       }
      //     });
      //   }
      // }
    },
    savePlus() {
      let flag = true;
      this.ruleForms.cardRuleRelList.forEach(v => {
        if (v.originCardTypeIdList.length === 0 || v.targetCardTypeId === "") {
          flag = false;
        }
      });
      if (flag) {
        let params = this.ruleForms;

        this.$store.dispatch("plusBasicConfig", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });

            this.plusModalVisible = false;
            this.queryList();
          }
        });
      } else {
        this.$message({
          message: "请选择会员卡升级类型",
          type: "warning"
        });
      }
    },
    handleClose(done) {
      done();
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    openRuleSelector() {
      this.ruleDialogVisible = true;
      // this.title = "会员限制";
      // this.tagModalVisible = true;
      // setTimeout(() => {
      //   this.resetRuleForm();
      // }, 0);
    },
    toRule(type, row) {
      this.$router.push({
        name: "PlusLeveLUpRule",
        query: {
          cardType: row ? row.cardType : this.cardType,
          plusRuleId: row ? row.plusRuleId : undefined,
          type: row ? type : undefined
        }
      });
      this.ruleDialogVisible = false;
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.cardName = "";
      this.ruleForm.wxshopSpuName = "";
      this.ruleForm.remark = "";
      this.ruleForm.quota = "";
      this.ruleForm.description = "";
      this.ruleForm.plusRuleId = "";
      this.ruleForm.wxshopSkuId = "";
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteGoodsCategory", {
            categoryId: row.categoryId
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.$store.commit("QUERY_GOOD_CATEGORY_LIST", {
                result: { record: [] }
              });
              this.queryList();
            }
          });
      });
    },
    confirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          params.wxshopSkuId = this.wxshopSkuId;

          this.$store.dispatch("addPlusRuleList", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              setTimeout(() => {
                this.resetRuleForm();
              }, 0);
              this.tagModalVisible = false;
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    canel() {
      this.tagModalVisible = false;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    search() {
      // this.createTimeStart =
      //   this.searchCondition.date && this.searchCondition.date.length > 0
      //     ? this.searchCondition.date[0]
      //     : "";
      // this.createTimeEnd =
      //   this.searchCondition.date && this.searchCondition.date.length > 0
      //     ? this.searchCondition.date[0]
      //     : "";

      this.currentPage = 1;
      this.queryList();
    },
    filterGt0OrFixed(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "");

      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    // 过滤大于0且如果是小数保留两位
    filterGt0OrFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    getCheckedEmployee(selection) {
      this.checkedEmployee = selection.employeeId;
    },
    keep() {
      let params = {};
      params.belongEmployeeId = this.checkedEmployee;
      params.memberCardIds = [this.cardId];

      this.$store.dispatch("batchAllocation", params).then(res => {
        if (res.code == 0) {
          this.dialogVisible = false;
          this.queryList();
        }
      });
    }
  }
};
</script>
<style lang="scss">
.rule-dialog-body {
  .el-radio__input {
    opacity: 0;
  }
  .radio-inner {
    position: relative;
    width: 310px;
    height: 171px;
    border: 1px solid transparent;
    border-radius: 6px;
    overflow: hidden;
    &.basic {
      background: url("https://imgcdn.hemiao100.com/decoration/SketchPng3d6670ea22f7112d5c9f5ac9abb3cc42debbf8ed3a9d4814ddf9053dcc2e4cd4.png")
        no-repeat 0/ 100% 100%;
    }
    &.increase {
      background: url("https://imgcdn.hemiao100.com/decoration/SketchPngf0d1f1b37b3c1fb412a3e6e48ec67e292f08a397cea57f97a7c4bbd575f91631.png")
        no-repeat 0/ 100% 100%;
    }
    &.active {
      border: 1px solid #e50065;
      &::before {
        content: "";
        position: absolute;
        top: -31px;
        left: -15px;
        background: #e50065;
        width: 40px;
        height: 50px;
        transform: rotate(45deg);
      }
      .hmicon {
        position: absolute;
        top: 4px;
        left: 2px;
        color: #fff;
        font-size: 12px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.title {
  margin-bottom: 10px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.priview {
  position: relative;
  width: 330px;
  height: 136px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
